import type { SnippetOwner } from '../../types/snippetOwner.ts';

/** Module-level cache keyed by accountId.toLowerCase() for reuse across requests. */
export const USER_CACHE: Map<string, SnippetOwner> = new Map<string, SnippetOwner>();

/** Clears the user cache. Exported for test isolation. */
export const clearUserCacheForTesting = (): void => {
	USER_CACHE.clear();
};
